import Vue from 'vue';
import Vuex from 'vuex';
import {
	getToken,
	setToken,
	removeToken
} from '@/utils/auth'
Vue.use(Vuex);
//const store = new Vuex.Store();
const store = new Vuex.Store({
	state: {
		token: getToken(),
		name: '',
		avatar: '',
		roles: [],
		code:"",
		// isLock: getStore({
		// 	name: 'isLock'
		// }) || false,
		// lockPasswd: getStore({
		// 	name: 'lockPasswd'
		// }) || '',
		// browserHeaderTitle: getStore({
		// 	name: 'browserHeaderTitle'
		// }) || 'NxAdmin'
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		},
	},
	actions: {
		// 登录
		Login({
			commit
		}, userInfo) {
			//const username = userInfo.username.trim()
			return new Promise((resolve, reject) => {
				debugger
				// login(username, userInfo.password).then(response => {
				// 	const data = response
				// 	setToken(data.token)
				// 	commit('SET_TOKEN', data.token)
				// 	resolve()
				// }).catch(error => {
				// 	reject(error)
				// })
				sessionStorage.setItem('userinfo', JSON.stringify(userInfo))

				setToken("Y")
				commit('SET_TOKEN', "Y")
				resolve()
			})
		},
    logout({commit}){
      return new Promise((resolve, reject) => {
debugger
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
         // commit('CLEAR_LOCK')
          removeToken()
          sessionStorage.clear()
          resolve()

      })
    },
		SetRoles({
			commit
		}, Rols) {
			return new Promise((resolve, reject) => {
				//debugger
				commit('SET_ROLES', Rols)
				resolve()
			})

		}

	},
	getters: { // getters
		roles: function(state) {
			//debugger
			return state.roles
		}
	}
})

export default store;

export function login(username, password) {
	return request({
		url: '/user/login',
		method: 'post',
		data: {
			username,
			password
		}
	})
}

export function getInfo(token) {
	return request({
		url: '/user/info',
		method: 'get',
		params: {
			token
		}
	})
}

export function logout() {
	return request({
		url: '/user/logout',
		method: 'post'
	})
}



// WEBPACK FOOTER //
// ./src/store/index.js